import { SearchOutlined, RedoOutlined, EditOutlined, SaveOutlined, DownloadOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, DatePickerProps, Form, Input, InputNumber, Row, Table, Tag } from "antd";
import Column from 'antd/es/table/Column';
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import { searchLength } from '../../constants';
import { Links } from "../../helpers/Links";
import { menuHelper } from "../../helpers/account";
import { dateCommon, thoiGianCongTacCommon, validateMessages } from '../../helpers/common';
import { TimKiemNgayPhepTrongNam, khoiTaoPhepNam, luuNgayPhepTrongNam } from '../../services/donnghiphep';
import dayjs, { Dayjs } from 'dayjs';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { useDispatch } from 'react-redux';
import ModalTextForm from '../../components/modal/ModalTextForm';
import viVN from 'antd/lib/date-picker/locale/vi_VN';
import { TimKiemNgayPhepTrongNamPagingResponse, NgayPhepTrongNam } from '@app/models/donnghiphep/NgayPhepTrongNam';
import { xuatBaoCaoPhepNam } from '../../services/report';
import { Space } from 'antd/lib';

const QuanLyNgayPhepTrongNam = () => {
    const { TextArea } = Input;
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const menu: any = menuHelper.checkMultiPermission([Links.Phep.KhoiTaoPhepNam, Links.Phep.luuNgayPhepTrongNam]);
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const [nam, setNam] = useState<string>(new Date().getFullYear().toString());
    const [namValue, setNamValue] = useState<Dayjs | null>(dayjs());
    const namFormat: DatePickerProps['format'] = (value) => `Năm ${value.format('YYYY')}`;
    const [showModalChiTiet, setShowModalChiTiet] = useState<boolean>(false);
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const [isLoadingBtn, setIsLoadingBtn] = useState<boolean>(false);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [danhSach, setDanhSach] = useState<TimKiemNgayPhepTrongNamPagingResponse>({
        "data": [],
        "recordsTotal": 0,
        "maxPage": 0,
        "pageCurrent": 0,
        "pageListShow": [0]
    });

    const setFormDetailModal = (value: NgayPhepTrongNam) => {
        form.setFieldsValue({
            "id": value?.id || 0,
            "nam": value?.nam || 0,
            "phepTieuChuan": value?.phepTieuChuan || 0,
            "phepThamNien": value?.phepThamNien || 0,
            "soNgayPhepTrongNam": value?.soNgayPhepTrongNam || 0,
            "soNgayDaNghi": value?.soNgayDaNghi || 0,
            "daDuyetChoChamCong": value?.daDuyetChoChamCong || 0,
            "dangChoDuyet": value?.dangChoDuyet || 0,
            //"soNgayConLai": (value?.soNgayPhepTrongNam + value?.soNgayMienGiam - value?.soNgayDaNghi - value?.daDuyetChoChamCong - value?.dangChoDuyet),
            "soNgayConLai": (value?.soNgayPhepTrongNam - value?.soNgayDaNghi - value?.daDuyetChoChamCong - value?.dangChoDuyet),
            "tuNgay": value?.tuNgay ? dayjs(dateCommon.formatDate(value.tuNgay), "DD/MM/YYYY") : null,
            "denNgay": value?.denNgay ? dayjs(dateCommon.formatDate(value.denNgay), "DD/MM/YYYY") : null,
            "idNhanVien": value?.idNhanVien || 0,
            "tenNhanVien": value?.tenNhanVien || "",
            "tenChucVu": value?.tenChucVu || "",
            "tenDonVi": value?.tenDonVi || "",
            "ngayTinhPhep": value?.ngayTinhPhep,
            "soThangLamCQNN": value?.soThangLamCQNN || 0,
            "soNgayMienGiam": value?.soNgayMienGiam || 0,
            "ghiChu": value?.ghiChu || "",
        });
        setShowModalChiTiet(true);
    }

    const timkiem = async (nam: string, tuKhoa: string, start: number, length: number, page: number) => {
        try {
            setPage(1);
            setIsLoadingTable(true);
            const temp = await TimKiemNgayPhepTrongNam(nam, tuKhoa, start, length);
            const maxPage = temp?.recordsTotal === 0 ? 0 : (parseInt((temp?.recordsTotal / searchLength).toString()) + (temp?.recordsTotal % searchLength ? 0 : -1)) || 0;
            setDanhSach({
                "data": (temp?.data || []).map((item: any) => { item.key = item.id; return item }),
                "recordsTotal": temp?.recordsTotal || 0,
                "maxPage": maxPage,
                "pageCurrent": page,
                "pageListShow": []
            });
            setIsLoadingTable(false);
        }
        catch (error: any) {
            toast.error(error);
            setIsLoadingTable(false);
        };
    }

    const xuatBaoCao = async (nam: string, tuKhoa: string) => {
        try {
            setIsLoadingTable(true);
            var response = await xuatBaoCaoPhepNam({ thoiGian: nam, tuKhoa: tuKhoa });
            let link = document.createElement('a');

            link.download = `QuanLyPhepNam.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
            setIsLoadingTable(false);
        } catch (error: any) {
            toast.error(error || 'Có lỗi xảy ra');
            setIsLoadingTable(false);
        }
    }
    const onChange: DatePickerProps['onChange'] = (year) => {
        var yearStr = year?.format('YYYY');
        if (yearStr) {
            setNamValue(year);
            setNam(yearStr);
            timkiem(yearStr, tuKhoa, 0, 0, 0);
        }
    }

    const onFinish = async (values: any) => {
        try {
            dispatch(showLoadingScreen());
            setIsLoadingBtn(true);
            await luuNgayPhepTrongNam(values);
            
            toast.success('Lưu thông tin thành công!')
        }
        catch (err: any) {
            
            toast.error('Đã xảy ra lỗi, lưu không thành công!');
        }
        dispatch(hideLoadingScreen());
        setIsLoadingBtn(false);
        setReloadPage(true);
        //setShowModalChiTiet(false);
    };

    const onKhoiTaoPhepNam = async () => {
        try {
            dispatch(showLoadingScreen());
            await khoiTaoPhepNam(nam);
            toast.success('Khởi tạo phép năm thành công');
            setReloadPage(true);
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, khởi tạo phép năm không thành công');
        }

        dispatch(hideLoadingScreen());
    }

    useEffect(() => {
        if (reloadPage) {
            setDanhSach({
                "data": [],
                "recordsTotal": 0,
                "maxPage": 0,
                "pageCurrent": 0,
                "pageListShow": [0]
            });
            timkiem(nam, tuKhoa, 0, 0, 0);
            setReloadPage(false);
        }
    }, [reloadPage]);

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            timkiem(nam, tuKhoa, 0, 0, 0);
        }
    };
    return (
        <section>
            {!isLoadingBtn && showModalChiTiet && <ModalTextForm title={"Thông tin phép năm " + nam}
                hideFooter
                show={showModalChiTiet}
                handleClose={() => setShowModalChiTiet(false)}
            >
                <Form
                    layout="vertical"
                    validateMessages={validateMessages}
                    onFinish={onFinish}
                    form={form}
                > 
                    <Form.Item hidden name="id" key="id"><Input /></Form.Item>
                    <Form.Item hidden name="idNhanVien" key="idNhanVien"><Input /></Form.Item>
                    <Form.Item name="tenNhanVien">
                        <div>
                            <span style={{ fontSize: '20px', fontWeight: 'bold', padding: '4px' }} key="tenNhanVien">[ {form.getFieldValue('tenNhanVien')} ]</span>
                            <Tag color="blue" key="tenDonVi" >{form.getFieldValue('tenDonVi')}</Tag>
                            <Tag color="green" style={{ marginLeft: '4px' }} key="tenChucVu">{form.getFieldValue('tenChucVu')}</Tag>
                            <br />
                            <Tag color="red" style={{ marginLeft: '4px' }} key="ngayTinhPhep">Ngày tính phép: {form.getFieldValue('ngayTinhPhep')}</Tag>
                            {
                                form.getFieldValue('soThangLamCQNN') > 0 &&
                                <Tag color="orange" style={{ marginLeft: '4px' }} key="soThangLamCQNN">Thời gian làm CQNN: {thoiGianCongTacCommon.hienThi(form.getFieldValue('soThangLamCQNN'))}</Tag>
                            }
                        </div>
                    </Form.Item>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="tuNgay" key="tuNgay" label="Từ ngày" >
                                <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Từ Ngày" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} disabled />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="denNgay" key="denNgay"  label="Đến ngày" >
                                <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Đến Ngày" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} disabled />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Col span={12}>
                        <Form.Item
                            key="nam"
                            label="Năm"
                            name="nam"
                            hidden >
                            <Input placeholder="Năm" disabled />
                        </Form.Item>
                    </Col>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Tổng số ngày phép trong năm"
                                key="soNgayPhepTrongNam"
                                name="soNgayPhepTrongNam" >
                                <InputNumber style={{ width: "100%" }} disabled />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Số ngày không trừ phép"
                                key="soNgayMienGiam"
                                name="soNgayMienGiam" hidden >
                                <InputNumber style={{ width: "100%" }} onChange={(e: any) => {
                                    form.setFieldValue('soNgayConLai', e + form.getFieldValue('phepThamNien') + form.getFieldValue('phepTieuChuan') - form.getFieldValue('soNgayDaNghi'));
                                }}
                                min={0} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Số ngày phép tiêu chuẩn"
                                key="phepTieuChuan"
                                name="phepTieuChuan" >
                                <InputNumber style={{ width: "100%" }} onChange={(e: any) => {
                                    form.setFieldValue('soNgayPhepTrongNam', e + form.getFieldValue('phepThamNien'));
                                    form.setFieldValue('soNgayConLai', e + form.getFieldValue('phepThamNien') + form.getFieldValue('soNgayMienGiam') - form.getFieldValue('soNgayDaNghi'));
                                }}
                                min={0} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Phép thâm niên"
                                key="phepThamNien"
                                name="phepThamNien" >
                                <InputNumber style={{ width: "100%" }} onChange={(e: any) => {
                                    form.setFieldValue('soNgayPhepTrongNam', e + form.getFieldValue('phepTieuChuan'));
                                    form.setFieldValue('soNgayConLai', e + form.getFieldValue('phepTieuChuan') + form.getFieldValue('soNgayMienGiam') - form.getFieldValue('soNgayDaNghi'));
                                }}
                                min={0} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Số ngày đã nghỉ"
                                key="soNgayDaNghi"
                                name="soNgayDaNghi" >
                                <InputNumber style={{ width: "100%" }} onChange={(e: any) => {
                                    form.setFieldValue('soNgayConLai', form.getFieldValue('soNgayPhepTrongNam') - form.getFieldValue('daDuyetChoChamCong') - form.getFieldValue('dangChoDuyet') - e);
                                }} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Chờ chấm công"
                                key="daDuyetChoChamCong"
                                name="daDuyetChoChamCong" >
                                <InputNumber style={{ width: "100%" }} disabled />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Đang chờ duyệt"
                                key="dangChoDuyet"
                                name="dangChoDuyet" >
                                <InputNumber style={{ width: "100%" }} disabled />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Số ngày còn lại"
                                key="soNgayConLai"
                                name="soNgayConLai" >
                                <InputNumber style={{ width: "100%" }} disabled />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label="Ghi chú"
                                key="ghiChu"
                                name="ghiChu" >
                                <TextArea rows={3} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item>
                        <Button type="primary" loading={isLoadingBtn} className="float-right" htmlType="submit" icon=<SaveOutlined rev="" />>
                            Lưu
                        </Button>
                    </Form.Item>
                </Form>
            </ModalTextForm>}
            <ContentHeader title="Quản lý phép năm" />
            <Row gutter={8} className="form-group">
                <Col span={4}>
                    <DatePicker changeOnBlur={true} value={namValue} style={{ width: "100%" }} placeholder="Chọn năm" picker="year" format={namFormat} onChange={onChange} />
                </Col>
                <Col span={6}>
                    <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập tên, phòng ban, chức vụ " onChange={(e) => setTuKhoa(e.target.value)}
                        onKeyPress={handleKeyPress} />
                </Col>
                <Col span={4}>
                    <Space>
                        <Button type="primary" icon={<SearchOutlined rev="" />} onClick={() => timkiem(nam, tuKhoa, 0, 0, 0)}>
                            Tìm kiếm
                        </Button>
                        <Button className="hrm-btn hrm-btn-success"
                            icon={<DownloadOutlined rev="" />}
                            onClick={() => {
                                xuatBaoCao(nam, tuKhoa);
                            }}>
                            Xuất excel
                        </Button>
                    </Space>
                </Col>
                <Col span={10}>
                    {
                        menu[Links.Phep.KhoiTaoPhepNam] &&
                        <Button className="hrm-btn float-right hrm-btn-warning" onClick={onKhoiTaoPhepNam}>
                            <RedoOutlined rev="" />Khởi tạo phép năm
                        </Button>
                    }
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <div className="card card-primary">
                        <Table
                            dataSource={danhSach.data}
                            loading={isLoadingTable}
                            locale={{ emptyText: "Không có dữ liệu" }}
                            rowKey={(record) => record.id}
                            sticky
                            pagination={{
                                current: page,
                                onChange: (page, pageSize) => {
                                    setPage(page);
                                },
                            }}
                        >
                            <Column title="STT" key="STT" width="60px" render={(value, record, index) =>
                                (<span key={"stt" + index}> {(page - 1) * searchLength + index + 1}</span>)
                            } />
                            <Column title="Họ tên" dataIndex="tenNhanVien" key="tenNhanVien" />
                            <Column title="Phòng ban" dataIndex="tenDonVi" key="tenDonVi" />
                            <Column title="Năm" dataIndex="nam" key="nam" />
                            <Column title="Phép tiêu chuẩn" dataIndex="phepTieuChuan" key="phepTieuChuan" />
                            <Column title="Phép thâm niên" dataIndex="phepThamNien" key="phepThamNien" />
                            <Column title="Tổng cộng" dataIndex="soNgayPhepTrongNam" key="soNgayPhepTrongNam" />
                            <Column title="Đã nghỉ" dataIndex="soNgayDaNghi" key="soNgayDaNghi" />
                            <Column title="Chờ chấm công" dataIndex="daDuyetChoChamCong" key="daDuyetChoChamCong" />
                            <Column title="Đang chờ duyệt" dataIndex="dangChoDuyet" key="dangChoDuyet" />
                            <Column title="Còn lại" key="soNgayConLai" render={(value: NgayPhepTrongNam, record: any) =>
                                (<span>{(value?.soNgayPhepTrongNam + value?.soNgayMienGiam - value?.soNgayDaNghi - value?.daDuyetChoChamCong - value?.dangChoDuyet)}</span>)
                            } />
                            <Column title="Thời gian " key="tuNgay" render={(value, record: any) =>
                                (<span>{dateCommon.formatDate(record.tuNgay)} - {dateCommon.formatDate(record?.denNgay)}</span>)
                            } />
                            {
                                menu[Links.Phep.KhoiTaoPhepNam] && 
                                <Column title="" dataIndex="action" key="action" render={(value: any, record: any) => {
                                    return <Button type="primary" size={"small"} title="Sửa"
                                        icon=<EditOutlined rev="" />
                                        onClick={() => { setFormDetailModal(record); }}
                                    >
                                        Sửa
                                    </Button>;
                                }} />
                            }
                        </Table>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default QuanLyNgayPhepTrongNam;